import { Expose, Type } from "class-transformer";
import type { ProfileCompletionLevelEnum } from "../../constants/profile-completion-level.enum";
import { ProfileSection } from "../profile-section/profile-section.entity";
import type { IProfileSection } from "../profile-section/profile-section.entity.interface";
import type { IProfileCompletion } from "./profile-completion.entity.interface";

export class ProfileCompletion implements IProfileCompletion {
  @Expose()
  @Type(() => ProfileSection)
  sections!: IProfileSection[];

  @Expose()
  activeStep!: ProfileCompletionLevelEnum;
}
